import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useConfig, telHref } from "@/lib/config";

const CITIES = [
  { label: "Noida", to: "/packers-movers-noida" },
  { label: "Greater Noida", to: "/packers-movers-greater-noida" },
  { label: "Ghaziabad", to: "/packers-movers-ghaziabad" },
  { label: "Gurugram", to: "/packers-movers-gurugram" },
  { label: "Faridabad", to: "/packers-movers-faridabad" },
  { label: "Delhi", to: "/packers-movers-delhi" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [citiesOpen, setCitiesOpen] = useState(false);
  const cfg = useConfig();

  return (
    <>
      {/* Top strip */}
      <div className="hidden md:block bg-[#0F172A] text-white text-xs">
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between">
          <span>GSTIN Verified • Transit Insured • 15+ Years in Delhi NCR</span>
          <a href={telHref(cfg.contact_phone)} className="hover:text-[#F97316] font-medium" data-testid="top-strip-call">
            <Phone className="inline w-3 h-3 mr-1" /> 24×7 Helpline: {cfg.contact_phone || "+91 99999 99999"}
          </a>
        </div>
      </div>

      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#1E3A8A] to-[#F97316] grid place-items-center text-white font-black text-lg font-display">MV</div>
            <div className="leading-tight">
              <div className="font-display font-extrabold text-[#0F172A] text-sm sm:text-base">Maa Vindhyavasini</div>
              <div className="text-[9px] uppercase tracking-wider text-slate-500">Packers Movers & Transport</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-6 text-sm font-medium text-slate-700">
            <NavLink to="/" className={({ isActive }) => isActive ? "text-[#1E3A8A]" : "hover:text-[#1E3A8A]"} data-testid="nav-home">Home</NavLink>
            <div className="relative" onMouseEnter={() => setCitiesOpen(true)} onMouseLeave={() => setCitiesOpen(false)}>
              <button className="hover:text-[#1E3A8A]" data-testid="nav-cities">Cities ▾</button>
              {citiesOpen && (
                <div className="absolute left-0 top-full pt-2 w-56">
                  <div className="bg-white border border-slate-200 rounded-lg shadow-xl py-2">
                    {CITIES.map((c) => (
                      <Link key={c.to} to={c.to} className="block px-4 py-2 hover:bg-orange-50 hover:text-[#F97316]" data-testid={`city-nav-link-${c.label.toLowerCase().replace(/\s/g, "-")}`}>{c.label}</Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <NavLink to="/services" className={({ isActive }) => isActive ? "text-[#1E3A8A]" : "hover:text-[#1E3A8A]"} data-testid="nav-services">Services</NavLink>
            <NavLink to="/blog" className={({ isActive }) => isActive ? "text-[#1E3A8A]" : "hover:text-[#1E3A8A]"} data-testid="nav-blog">Blog</NavLink>
            <NavLink to="/about" className={({ isActive }) => isActive ? "text-[#1E3A8A]" : "hover:text-[#1E3A8A]"} data-testid="nav-about">About</NavLink>
            <NavLink to="/contact" className={({ isActive }) => isActive ? "text-[#1E3A8A]" : "hover:text-[#1E3A8A]"} data-testid="nav-contact">Contact</NavLink>
          </nav>

          <div className="flex items-center gap-3">
            <Button asChild className="bg-[#F97316] hover:bg-[#EA580C] text-white rounded-full px-5 shadow-md" data-testid="navbar-quote-btn">
              <Link to="/contact">Get Free Quote</Link>
            </Button>
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2" data-testid="mobile-menu-toggle" aria-label="menu">
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t bg-white px-4 py-4 space-y-1">
            {[{ to: "/", label: "Home" }, ...CITIES, { to: "/services", label: "Services" }, { to: "/blog", label: "Blog" }, { to: "/about", label: "About" }, { to: "/contact", label: "Contact" }].map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-slate-700 hover:text-[#1E3A8A]" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
            ))}
          </div>
        )}
      </header>
    </>
  );
}
